<template>
	<section class="links-section" :style="sectionVars">
		<div class="container">
			<ul class="links-section__grid">
				<li v-for="(item, i) in items" :key="i" class="links-section__item">
					<a
						v-if="item.link"
						:href="item.link"
						target="_blank"
						rel="noopener"
						class="links-section__box"
					>
						<img
							v-if="item.icon"
							:src="item.icon"
							class="links-section__icon"
							:alt="item.label || ''"
						/>
						<span v-if="item.label" class="links-section__label">{{
							item.label
						}}</span>
					</a>
					<!-- no destination yet: render the box, but not as a dead link -->
					<div v-else class="links-section__box is-disabled">
						<img
							v-if="item.icon"
							:src="item.icon"
							class="links-section__icon"
							:alt="item.label || ''"
						/>
						<span v-if="item.label" class="links-section__label">{{
							item.label
						}}</span>
					</div>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
export default {
	name: 'LinksSection',
	props: {
		// [{ label, icon, link }] -- label and link are both optional
		items: {
			type: Array,
			default: () => [],
		},
		columns: { type: Number, default: 6 },
		backgroundColor: { type: String, default: '#050535' },
		borderColor: { type: String, default: '#4656FF' },
		textColor: { type: String, default: '#E8E8FF' },
	},
	components: {},
	data: () => ({}),
	created() {},
	computed: {
		sectionVars() {
			return {
				'--bg': this.backgroundColor,
				'--border': this.borderColor,
				'--text': this.textColor,
				'--columns': this.columns,
			};
		},
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
.links-section {
	width: 100%;
	background-color: var(--bg);
	padding: 32px 0;

	@media (max-width: $breakpoint-sm) {
		padding: 24px 0;
	}
}

.links-section__grid {
	display: grid;
	grid-template-columns: repeat(var(--columns), 1fr);
	gap: 20px;
	margin: 0;
	padding: 0;
	list-style: none;

	@media (max-width: $breakpoint-md) {
		grid-template-columns: repeat(3, 1fr);
		gap: 14px;
	}

	@media (max-width: $breakpoint-sm) {
		grid-template-columns: repeat(2, 1fr);
	}
}

.links-section__box {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 100%;
	min-height: 56px;
	padding: 12px;
	border: 1px solid var(--border);
	background: transparent;
	color: var(--text);
	transition: $transition-global;

	&:hover {
		background: var(--border);
		color: var(--text);
	}

	// no dimming: a missing destination is a content gap, not a visual state
}

.links-section__icon {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
	object-fit: contain;
}

.links-section__label {
	font-family: 'HKNova', sans-serif;
	font-size: $text-m;
	line-height: 20px;
	color: var(--text);

	@media (max-width: $breakpoint-md) {
		font-size: $text-s;
	}
}
</style>
